/* eslint-disable camelcase */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en_USLang from './translations/en_US';

const resources = {
  en: en_USLang,
};

//
i18n
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    // we init with resources
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      wait: true,
    },
  });

export default i18n;
